import s from './withCheckboxTable.module.scss';
var FIXED_POSITION = 'left';
var DEFAULT_WIDTH = 50;
var DEFAULT_ID = '_checkBoxColumn';
export var BASE_CHECKBOX_COLUM = {
  id: DEFAULT_ID,
  width: DEFAULT_WIDTH,
  fixed: FIXED_POSITION,
  sortable: false,
  resizable: false,
  filterable: false,
  className: "".concat(s.checkboxContainer, " ").concat(s.checkboxCell)
};
export var DEFAULT_ROW_HEIGHT = 30;
export var KEYBOARD_EVENTS = {
  KEY_UP: 'keyup',
  KEY_DOWN: 'keydown'
};
export var SHIFT_KEY_CODE = 16;